export { default as InducteeImpactHero } from './InducteeImpactHero';